var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner"}),_vm._t("default"),_c('div',{attrs:{"id":"nav"}},[_c('ul',{staticClass:"d_flex"},_vm._l((_vm.navList),function(el,idx){return _c('li',{key:idx},[_c('router-link',{attrs:{"to":el.href}},[_c('img',{attrs:{"src":require(`../assets/images/${el.imgSrc}${
                                _vm.currentRouteName === idx ? 'On' : 'Off'
                            }.svg`),"alt":""}}),_c('p',{class:{
                            active:
                                _vm.currentRouteName === idx ? 'active' : '',
                        }},[_vm._v(" "+_vm._s(el.name)+" ")]),(!!el.notify)?_c('font',{staticClass:"notify"},[_vm._v(_vm._s(el.notify))]):_vm._e()],1)],1)}),0)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }